module.exports = __webpack_public_path__ + "static/583-840a09ba3ac0a4994bf035cc895b014a.png";